(ns core.db.entity.tree)

(defn eager-ancestors [entity]
  (when entity
    (cons entity (-> entity
                     :entity/parent
                     eager-ancestors))))

(defn lazy-ancestors [entity]
  (when entity
    (cons entity (-> entity
                     :entity/parent
                     lazy-ancestors
                     lazy-seq))))
